import _             from 'underscore';
import React, { FC } from 'react';

import { useQuery }                                         from '@apollo/react-hooks';
import { DecisionEngineQueries }                            from '../../../../queries';
import { formatOption }                                     from '../../../../util';
import { SelectField }                                      from '../../../components/forms';
import { ComponentWithLoadingFlag, PreSelectedSelectField } from '../../../../types';
import { queriesHaveData, queriesLoading }                  from '../../../../store/_apolloUtil';

interface Props extends ComponentWithLoadingFlag, PreSelectedSelectField {}

const defaultProps: Props = {
	loading: false
}

const QueryDropdown: FC<Props> = ( _props ) => {
	
	let { formatOptions, ...props } = _props;
	
	let getObjectiveGroupsReq = useQuery( DecisionEngineQueries.queries.GET_OBJECTIVES( `id name` ), { fetchPolicy: 'cache-and-network' } );
	
	let isLoading = ( props.loading || queriesLoading( getObjectiveGroupsReq ) );
	
	let options = ( queriesHaveData( getObjectiveGroupsReq ) )
	              ? _.sortBy( getObjectiveGroupsReq.data.objectives, 'name' ).map( ( { id, name } ) => formatOption( id, name, formatOptions ) )
	              : [];
	
	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

QueryDropdown.defaultProps = {
	loading:       false,
	formatOptions: {}
};

export { QueryDropdown as ObjectiveGroupDropdown };
